export function dataInRequest(params = {}) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradadmdadosfaturamentoseplag/RECORD_FILTERING',
    payload: { params },
  };
}
